import { useTranslation } from 'react-i18next';

const formats = [
  { titleKey: 'aboutAcademy.format.1.title', descKey: 'aboutAcademy.format.1.desc', icon: 'ri-calendar-check-line' },
  { titleKey: 'aboutAcademy.format.2.title', descKey: 'aboutAcademy.format.2.desc', icon: 'ri-group-line' },
  { titleKey: 'aboutAcademy.format.3.title', descKey: 'aboutAcademy.format.3.desc', icon: 'ri-play-circle-line' },
];

export default function ClassFormat() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('aboutAcademy.format.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('aboutAcademy.format.title')}
          </h2>
          {String(t('aboutAcademy.format.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('aboutAcademy.format.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[2] max-w-[760px] mx-auto text-left md:text-center">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {formats.map((format) => (
            <div
              key={format.titleKey}
              className="card-glow bg-background-100/60 border border-background-200/60 p-6 md:p-8 flex flex-col items-start cursor-default"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-5">
                <i className={`${format.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                {t(format.titleKey)}
              </h3>
              {String(t(format.descKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.95]">{__s}</p>))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
